import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BuildingStimulus;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import { chooseDragConnection, usingIE } from '../../../../../common/components/shared/drag_and_drop/dragAndDropUtils';
import DragHandle from '../../../../../common/components/shared/drag_and_drop/DragHandle';
import DragAndDropZone from '../../../../../common/components/shared/drag_and_drop/DragAndDropZone';
import CommonStimulus from '../../../../../common/components/layout/sidebar/Stimulus';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var BuildingStimulus = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BuildingStimulus = /*#__PURE__*/function (_Component) {
  function BuildingStimulus() {
    _classCallCheck(this, BuildingStimulus);
    return _callSuper(this, BuildingStimulus, arguments);
  }
  _inherits(BuildingStimulus, _Component);
  return _createClass(BuildingStimulus, [{
    key: "shouldDisableDragHandle",
    value: function shouldDisableDragHandle() {
      var _this$props = this.props,
        childEntries = _this$props.childEntries,
        quizEntries = _this$props.quizEntries;
      return quizEntries.size === (childEntries && childEntries.size || 0) + 1;
    }
  }, {
    key: "renderDragHandle",
    value: function renderDragHandle() {
      var _this$props2 = this.props,
        connectDragSource = _this$props2.connectDragSource,
        sidebarOpen = _this$props2.sidebarOpen;
      if (sidebarOpen) {
        var dragHandle =
        // This wrapper div is necessary for drag and drop
        jsx("div", null, jsx(DragHandle, {
          disabled: this.shouldDisableDragHandle(),
          displayPosition: this.props.displayPosition,
          onSidebar: true,
          quizEntry: this.props.quizEntry,
          quizEntries: this.props.quizEntries
        }));
        if (this.shouldDisableDragHandle()) {
          return dragHandle;
        }
        var handleWrapper = usingIE() ? function (C) {
          return C;
        } : connectDragSource;
        return handleWrapper(dragHandle);
      }
    }
  }, {
    key: "renderStimulus",
    value: function renderStimulus() {
      return jsx(CommonStimulus, {
        displayPosition: this.props.displayPosition,
        draggingOver: this.props.draggingOver,
        draggingAboveHalf: this.props.draggingAboveHalf,
        dropIntoEmptyStimulus: this.props.dropIntoEmptyStimulus,
        isDragging: this.props.isDragging,
        isOver: this.props.isOver,
        itemId: this.props.itemId,
        stimulusParent: this.props.quizEntry,
        renderSidebarItem: this.props.renderSidebarItem,
        sidebarOpen: this.props.sidebarOpen
      }, this.renderDragHandle());
    }
  }, {
    key: "renderStimulusWrapper",
    value: function renderStimulusWrapper() {
      var propsForDnDZone = {
        inSidebar: true,
        inStimulus: true,
        sidebarOpen: this.props.sidebarOpen,
        draggingOver: this.props.draggingOver,
        draggingAboveHalf: this.props.draggingAboveHalf,
        dropIntoEmptyStimulus: this.props.dropIntoEmptyStimulus
      };
      return jsx("div", null, jsx("div", {
        css: this.props.styles.sidebarStimulusWrapper
      }, jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "above"
      })), this.renderStimulus(), jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "in"
      })), jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "below"
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        connectDragPreview = _this$props3.connectDragPreview,
        connectDragSource = _this$props3.connectDragSource,
        connectDropTarget = _this$props3.connectDropTarget,
        sidebarOpen = _this$props3.sidebarOpen;
      var dragConnection = chooseDragConnection(connectDragSource, connectDragPreview);
      if (sidebarOpen && !this.shouldDisableDragHandle()) {
        return dragConnection(connectDropTarget(this.renderStimulusWrapper()));
      }
      return this.renderStimulusWrapper();
    }
  }]);
}(Component), _defineProperty(_BuildingStimulus, "displayName", 'BuildingStimulus'), _defineProperty(_BuildingStimulus, "componentId", "Quizzes".concat(_BuildingStimulus.displayName)), _defineProperty(_BuildingStimulus, "propTypes", {
  childEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  // inserted by React DnD
  connectDragSource: PropTypes.func.isRequired,
  // inserted by React DnD
  connectDropTarget: PropTypes.func.isRequired,
  // inserted by React DnD
  isDragging: PropTypes.bool.isRequired,
  // inserted by React DnD
  // Passed in by the Sidebar
  displayPosition: PropTypes.number.isRequired,
  isOver: PropTypes.bool,
  itemId: PropTypes.string.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  renderSidebarItem: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  // Passed in by connect
  draggingAboveHalf: PropTypes.bool.isRequired,
  draggingOver: PropTypes.bool.isRequired,
  dropIntoEmptyStimulus: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_BuildingStimulus, "defaultProps", {
  draggingAboveHalf: false,
  dropIntoEmptyStimulus: false,
  isOver: false
}), _BuildingStimulus)) || _class);
export default BuildingStimulus;